import React from 'react'
import { IntegrationServiceId } from '../../../common/integrations'
import { AdvisorEngineContactCreateFields } from './AdvisorEngineContactCreateFields'
import { WealthContactCreateFields } from './WealthContactCreateFields'

type ServiceSpecificContactCreateFieldsProps = {
  serviceId: IntegrationServiceId
}

export const ServiceSpecificContactCreateFields: React.FC<ServiceSpecificContactCreateFieldsProps> = ({ serviceId }) => {
  switch (serviceId) {
    case IntegrationServiceId.ADVISOR_ENGINE:
      return <AdvisorEngineContactCreateFields />
    case IntegrationServiceId.WEALTH:
      return <WealthContactCreateFields />
    default:
      return null
  }
}
